import TokensService from '@omni/kit/services/TokensService';

import BaseService, { IHttpResponse } from '../../../BaseService';
import { IPreparePassageUrl, preparePassageUrl } from '../BuildUrls';
import { IPassage } from '../Types';

const debug = require('debug')('tca:service:PassageService:Core:GetAll');

interface IPassageGetAll extends Omit<IPreparePassageUrl, 'id'> {
  getFromCache?: boolean;
  appKey?: string;
}

interface IPassagesGetAllResponse extends IHttpResponse {
  body?: {
    _embedded: {
      passages: IPassage[];
    };
  };
}

export default async ({
  getFromCache,
  appKey,
  ...buildUrlProps
}: IPassageGetAll): Promise<IPassagesGetAllResponse> => {
  debug('GetAll');
  const url = preparePassageUrl(buildUrlProps);

  const guestToken = await TokensService.getGuestToken();

  return BaseService.Get({
    url,
    appKey,
    getFromCache,
    token: guestToken,
  });
};
